import arabicTranslations from "./ar.json";
import englishTranslations from "./en.json";

const rtlLanguages = new Map();
rtlLanguages.set('ar');

const resources = {
  en: englishTranslations,
  ar: arabicTranslations,
};

const availableLanguages = Object.keys(resources);

export { availableLanguages, rtlLanguages, resources };
